import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import PropTypes from 'prop-types';
import React from 'react';
import EditModal from '../../common/modal/EditModal';
import EditAddressFields from './EditAddress';
import Address from './Address';
import RowDisplay from '../../common/RowDisplay';
import sortAddresses from '../../utils/sortAddresses';
var Addresses = function Addresses(props) {
  var _context;
  var addresses = props.addresses,
    addressTypes = props.addressTypes,
    deleteAddress = props.deleteAddress,
    groupId = props.groupId,
    updateOrCreateAddress = props.updateOrCreateAddress,
    lastUpdate = props.lastUpdate,
    shouldShowLastUpdate = props.shouldShowLastUpdate;
  var editSection = /*#__PURE__*/React.createElement(EditModal, {
    header: "Edit Address",
    size: "large",
    formName: "addresses",
    editButtonId: "edit-address-btn",
    id: "edit-address-modal"
  }, /*#__PURE__*/React.createElement(EditAddressFields, {
    addresses: addresses,
    groupId: groupId,
    updateOrCreateAddress: updateOrCreateAddress,
    deleteAddress: deleteAddress,
    addressTypes: addressTypes
  }));
  return /*#__PURE__*/React.createElement(RowDisplay, {
    editSection: editSection,
    label: "Address",
    lastUpdate: lastUpdate,
    showLastUpdate: shouldShowLastUpdate
  }, _mapInstanceProperty(_context = sortAddresses(addresses)).call(_context, function () {
    var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var i = arguments.length > 1 ? arguments[1] : undefined;
    return /*#__PURE__*/React.createElement("div", {
      className: "col-sm-6",
      key: i
    }, /*#__PURE__*/React.createElement(Address, {
      item: address
    }));
  }));
};
Addresses.propTypes = {
  addresses: PropTypes.array.isRequired,
  // groupId: PropTypes.string.isRequired,
  deleteAddress: PropTypes.func.isRequired,
  updateOrCreateAddress: PropTypes.func.isRequired,
  addressTypes: PropTypes.array.isRequired,
  lastUpdate: PropTypes.object,
  shouldShowLastUpdate: PropTypes.bool
};
Addresses.defaultProps = {
  addresses: [],
  lastUpdate: {
    recently_updated_by_name: null,
    recently_updated_at: null
  },
  shouldShowLastUpdate: false
};
export default Addresses;
//# sourceMappingURL=index.js.map